import React from 'react';

export enum SpinnerColor {
  Blue,
  White,
  Red,
}

interface IProps {
  height: string;
  width: string;
  containerClassName?: string;
  spinnerColor?: SpinnerColor;
}

const Spinner = ({ height, width, containerClassName, spinnerColor }: IProps) => {
  const getSpinnerColor = () => {
    switch (spinnerColor) {
      case SpinnerColor.Blue:
        return 'border-action03';
      case SpinnerColor.White:
        return 'border-bw00';
      case SpinnerColor.Red:
        return 'border-red02';

      default:
        return 'border-bw00';
    }
  };
  return (
    <div
      data-testid='spinner'
      className={`w-full !pl-0 h-full flex justify-center items-center relative ${containerClassName}`}
    >
      <div
        className={`border-b-2 rounded-full animate-spin ${getSpinnerColor()}`}
        style={{
          width,
          height,
        }}
      />
    </div>
  );
};

export default Spinner;
